export const APP_MODE_VERIFY_HOME_EVENT = 'checkcoa:app-mode-verify-home';

export function requestAppModeVerifyHome(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(APP_MODE_VERIFY_HOME_EVENT));
}
